import RaterPriceClientProduct from '@/modules/common/common/models/MID/RaterPriceClientProduct'
import type TravelInsuranceType from '../TravelInsuranceType'
import type TravelDestinationType from '../TravelDestinationType'

export default class TravelRaterPriceRequest {
  /** Lista de productos del cliente. (Opcional). */
  clientProducts: RaterPriceClientProduct[]

  /** Línea de negocio. Ejemplo: "AV01". (Obligatorio, String). */
  businessLine: string

  /** Fecha de inicio de seguro. Ejemplo: "2024-09-24". (Obligatorio, DateTime). */
  insuranceStartDate: string

  /** Tipo de seguro. Ejemplo: "6". (Obligatorio, Integer) */
  insuranceType: TravelInsuranceType

  /**  Destino. Ejemplo: "1". (Obligatorio, Integer). */
  destinationType: TravelDestinationType

  /** Fecha de inicio de viaje. Ejemplo: "2024-09-24". (Obligatorio, DateTime) */
  departureDate: string

  /** Fecha de vuelta del viaje. Ejemplo: "2024-09-28". (Obligatorio, DateTime) */
  returnDate: string

  /** Número de viajeros. Ejemplo: "1". (Obligatorio, Integer) */
  numberTravelers: number

  /** Si añade seguro de deportes. Ejemplo: "true". (Opcional, Boolean) */
  sportInsurance?: boolean

  /** Número de cotización. Ejemplo: "7747027". (Opcional, String). */
  quotationNumber: string | undefined

  /** Código de identificación de la cotización. Ejemplo: "27B3A7EA-876D-440D-9F53-3A16F7CD0226". (Opcional, GUID). */
  quotationId: string | undefined

  /** Si permite la cancelación. Ejemplo: "true". (Opcional, Boolean) */
  allowsCancellation?: boolean

  /** Si debe dejar registro en Senda o no */
  isQuote: boolean = false

  /** (String, opcional): Código del mediador. */
  mediator?: string

  constructor(data: any) {
    this.clientProducts = data.clientProducts?.map((c: any) => new RaterPriceClientProduct(c))
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insuranceType = data.insuranceType
    this.destinationType = data.destinationType
    this.departureDate = data.departureDate
    this.returnDate = data.returnDate
    this.numberTravelers = data.numberTravelers
    this.sportInsurance = data.sportInsurance
    this.quotationNumber = data.quotationNumber
    this.quotationId = data.quotationId
    this.allowsCancellation = data.allowsCancellation
    this.isQuote = data.isQuote
    if (data.mediator) this.mediator = data.mediator
  }
}
